import * as emailjs from '@emailjs/browser'
import emailConfigurationFor from './emailConfig'

export default async function sendEmail(form, params) {
  const configuration = emailConfigurationFor(form)
  return emailjs.send(
    configuration.serviceId,
    configuration.templateId,
    params,
    { publicKey: configuration.publicKey },
  )
}
